import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { authGuard } from "../../shared/auth/auth.guard";
import { ChatbotComponent } from './chatbot.component';

export const admin: Routes = [
  {
    path: "chatbot",
    loadComponent: () =>
      import("./chatbot.component").then((m) => m.ChatbotComponent),
    canActivate: [authGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class ChatbotRoutingModule {
  static routes = admin;
}
